import { Component, OnInit } from '@angular/core';
import { UmraPackagesService, ShortlistedPackage } from '../services/umra-packages.service';

@Component({
  selector: 'app-umra-reservation-user-requests-list',
  templateUrl: './umra-reservation-user-requests-list.component.html',
  styleUrls: ['./umra-reservation-user-requests-list.component.css']
})
export class UmraReservationUserRequestsListComponent implements OnInit {
  myPackages: ShortlistedPackage[] = [];
  loading = false;
  error: string | null = null;

  constructor(private approvalService: UmraPackagesService) { }

  ngOnInit(): void {
    this.loadMySubmissions();
  }

  loadMySubmissions(): void {
    this.loading = true;
    let userId = Number(localStorage.getItem("UserId"));
    // In a real app, you'd filter by user ID/email
    this.approvalService.getPendingApprovals().subscribe({
      next: (response) => {
        if (response.success) {
          this.myPackages = (response.data || []).filter(f => f.userId === userId);
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading submissions:', error);
        this.error = 'Failed to load your submissions';
        this.loading = false;
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'pending': return 'status-pending';
      case 'approved': return 'status-approved';
      case 'rejected': return 'status-rejected';
      default: return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'pending': return 'bi-clock';
      case 'approved': return 'bi-check-circle-fill';
      case 'rejected': return 'bi-x-circle-fill';
      default: return 'bi-question-circle';
    }
  }

  formatPrice(price: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    }).format(price);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}
